import request from '../utils/request'

export function sendCode(data) {
  return request({
    url: '/sms/send',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function monitorBiz(params) {
  return request({
    url: '/biz/mor',
    method: 'post',
    data:params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function reportBiz(params) {
  return request({
    url: '/biz/rp',
    method: 'post',
    data:params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function monitorChannelBiz(params) {
  return request({
    url: '/b_c/mor',
    method: 'post',
    data:params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function reportChannelBiz(params) {
  return request({
    url: '/b_c/rp',
    method: 'post',
    data:params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getChannelBizCategories(params) {
  return request({
    url: '/b_c/get',
    method: 'post',
    data:params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}




// WEBPACK FOOTER //
// ./src/api/h5Request.js